import { OnboardingStep } from "@/components/organisms/OnboardingFlowCard/onboardingFlowSteps";

/*
    Klaviyo Event
    @param site - site identifier, 1 for signup flow, 2 for price flow, 3 final flow.
    @param step - step, an action identifier given by a number.
    @param identify - identify, boolean, whether to identify object or not.
    @param object - the target object who's props are used for klaviyo identification.
*/
export const createKlaviyoEvent = (site: number, step: number, identify: boolean, object :any) => {
  let trackMessage = "";
  let location = site === 1 ? "Signup Flow" : "Price Flow";

  // Not sure about this to catch the klaviyo object or this is bad practice, for removing the error.
  let klaviyo = (window as any).klaviyo;


  if(site === 2){
    trackMessage = "Homeowner - Step 0, " + location + ", page view";
  }

  switch (step) {
    case step = 0:
        if(site === 1)
        trackMessage = "Homeowner - Step 0, " + location + ", page view";
      break;
    case step = 1:
      if(site === 1)
        trackMessage = "Homeowner - Step 1, " + location + ", completed";
      else
      trackMessage = "Homeowner - Step 1, " + location + ", Bedrooms/Sleeps added";
      break;
    case step = 2:
      if(site === 1)
        trackMessage = "Homeowner - Step 2, " + location + ", Bedrooms/Sleeps added";
      else
      trackMessage = "Homeowner - Step 2, " + location + ", distance to water added";
      break;
    case step = 3:
      if(site === 1)
        trackMessage = "Homeowner - Step 3, " + location + ", special facilities added";
      else
      trackMessage = "Homeowner - Step 3, " + location + ", Bathrooms added";
      break;
    case step = 4:
      if(site === 1)
        trackMessage = "Homeowner - Step 4, " + location + ", distance to water added";
        else
        trackMessage = "Homeowner - Step 4, " + location + ", size added";
      break;
    case step = 5:
      if(site === 1)
        trackMessage = "Homeowner - Step 5, " + location + ", property type added";
      else
      trackMessage = "Homeowner - Step 5, " + location + ", Pools added";
      break;
    case step = 6:
      if(site === 1)
        trackMessage = "Homeowner - Step 6, " + location + ", address and size added";
      else
      trackMessage = "Homeowner - Step 6, " + location + ", special facilities added";
      break;
    case step = 7:
      if(site === 1)
        trackMessage = "Homeowner - Step 7, " + location + ", rent prices added";
      else
      trackMessage = "Homeowner - Step 7, " + location + ", address & country added";
      break;
    case step = 8:
      if(site === 1)
        trackMessage = "Homeowner - Step 8, " + location + ", photos added";
        else
        trackMessage = "Homeowner - Step 8, " + location + ", signup completed";
      break;
    case step = 9:
      if(site === 1)
        trackMessage = "Homeowner - Step 9, " + location + ", cleaning added";
      else
      trackMessage = "Homeowner - Step 9, " + location + ", property type added";
      break;
    case step = 10:
      if(site === 1 || site === 3)
      trackMessage = "Homeowner - Step 10, " + location + ", Signup terms & conditions accepted";
      else
      trackMessage = "Homeowner - Step 10, " + location + ", photos added";
      break;
    case step = 11:
      trackMessage = "Homeowner - Step 11, " + location + ", rent prices added";
      break;
    case step = 12:
      trackMessage = "Homeowner - Step 12, " + location + ", cleaning added";
      break;
    case step = 13:
      trackMessage = "Homeowner - Step 13, " + location + ", Signup terms & conditions accepted";
      break;
    }

  if(!klaviyo){
    return
  }

  klaviyo.push(["track", trackMessage]);

  if(identify){
    klaviyo.push(['identify',
      {
        '$email' : object.value.email,
        '$first_name' :  object.value.firstName,
        '$last_name' :  object.value.lastName
      }
    ]);
  }
}

export const createKlaviyoEventV2 = (isEstimateFlow: boolean, stepNumber: number, step?: OnboardingStep, indentify?: {email: string, firstName: string, lastName: string}) => {
  let trackMessage = "";
  let location = isEstimateFlow ? "Estimate Flow" : "Signup Flow";
  let klaviyo = (window as any).klaviyo;
  if (!klaviyo) {
    return;
  }
  
  if (step == undefined) {
    trackMessage = `Homeowner - Step ${stepNumber}, ${location}, page view`;
  } else {
    switch (step) {
      case "propertyBasics":
        trackMessage = `Homeowner - Step ${stepNumber}, ${location}, property type, size, and sleeps added`;
        break;
      case "rooms":
        trackMessage = `Homeowner - Step ${stepNumber}, ${location}, bedrooms and bathrooms added`;
        break;
      case "facilities1":
        trackMessage = `Homeowner - Step ${stepNumber}, ${location}, pool/hot tub/sauna facilities added`;
        break;
      case "facilities2":
        trackMessage = `Homeowner - Step ${stepNumber}, ${location}, other facilities added`;
        break;
      case "suitableFor":
        trackMessage = `Homeowner - Step ${stepNumber}, ${location}, smoking and pet facilities added`;
        break;
      case "weeks":
        trackMessage = `Homeowner - Step ${stepNumber}, ${location}, weeks for rental added`;
        break;
      case "location":
        trackMessage = `Homeowner - Step ${stepNumber}, ${location}, location and built year added`;
        break;
      case "contact":
        trackMessage = `Homeowner - Step ${stepNumber}, ${location}, contact info added`;
        break;
      case "photos":
        trackMessage = `Homeowner - Step ${stepNumber}, ${location}, photos added`;
        break;
      case "pricing":
        trackMessage = `Homeowner - Step ${stepNumber}, ${location}, prices added`;
        break;
      case "cleaning":
        trackMessage = `Homeowner - Step ${stepNumber}, ${location}, cleaning added`;
        break;
      case "finish":
        trackMessage = `Homeowner - Step ${stepNumber}, ${location}, flow completed`;
        break;
      default:
        trackMessage = `Homeowner - Step ${stepNumber}, ${location}, unmapped step`;
        break;
    }
  }
  
  
  klaviyo.push(["track", trackMessage]);
  
  if (indentify) {
    klaviyo.push(['identify',
      {
        '$email': indentify.email,
        '$first_name': indentify.firstName,
        '$last_name': indentify.lastName
      }
    ]);
  }
}

export interface IBookingStarted {
  PropertyId: string | undefined;
  value: number | undefined;
  Area: {
      Path: string | undefined;
  };
  ImageURL: string | undefined;
  PropertyHeadline: string | undefined;
  CheckIn: Date | undefined;
  CheckOut: Date | undefined;
  City: string | undefined;
}

export const tryKlaviyoTrackBookingStarted = async (bookingStartedObject: IBookingStarted) => {
  waitForKlaviyoThen(() => {
    // @ts-ignore
    klaviyo.push(["track", "Started Booking", bookingStartedObject]);
  })
}

export interface IKlaviyoIdentify {
  email: string;
  firstName: string;
  lastName: string;
}

export const tryKlaviyoTrackStartedCheckout = async (identifyObject: IKlaviyoIdentify, bookingStartedObject: IBookingStarted) => {
  waitForKlaviyoThen(() => {
    // @ts-ignore
    klaviyo.push(['identify', {
      '$email': identifyObject.email,
      '$first_name': identifyObject.firstName,
      '$last_name': identifyObject.lastName
    }]);
    // @ts-ignore
    klaviyo.push(["track", "Started Checkout", bookingStartedObject]);
  })
}

export interface IKlaviyoDestination {
  AreaId: number;
  AreaName: string;
  ThemeId?: number | undefined;
  ImageUrl?: string | undefined;
}

export const klaviyoSearchResultPages = (klaviyoDestination: IKlaviyoDestination) => {
  waitForKlaviyoThen(() => {
    if (klaviyoDestination.ThemeId && !(klaviyoDestination.ThemeId > 0)) {
      klaviyoDestination.ThemeId = undefined;
    }
    // @ts-ignore
    klaviyo.push(['track', 'Viewed Area', klaviyoDestination]);
  })
}

export interface IKlaviyoProperty {
  PropertyId: string;
  ImageURL: string | undefined;
  Url: string;
}

export const klaviyoPropertyView = (klaviyoProperty: IKlaviyoProperty) => {
  waitForKlaviyoThen(() => {
    // @ts-ignore
    klaviyo.push(["track", "Viewed Property", {PropertyId: klaviyoProperty.PropertyId, ImageURL: klaviyoProperty.ImageURL}]);
    // @ts-ignore
    klaviyo.push(["trackViewedItem", klaviyoProperty]); 
  })
}

export const klaviyoShowCouponPopup = () => {
  waitForKlaviyoThen(() => {
    // @ts-ignore
    window._klOnsite = window._klOnsite || [];
    
    const hostElements = window.location.hostname.split('.')
    const domain = hostElements[hostElements.length - 1]
    switch (domain) {
      case 'dk':
        // @ts-ignore
        window._klOnsite.push(['openForm', 'Y9acf7']);
        break;
      case 'de':
        // @ts-ignore
        window._klOnsite.push(['openForm', 'UEXVvt']);
        break;
      case 'fr':
        // @ts-ignore
        window._klOnsite.push(['openForm', 'SALLEc']);
        break;
      case 'nl':
        // @ts-ignore
        window._klOnsite.push(['openForm', 'Swp2hJ']);
        break;
      case 'no':
        // @ts-ignore
        window._klOnsite.push(['openForm', 'RpeFxj']);
        break;
      case 'se':
        // @ts-ignore
        window._klOnsite.push(['openForm', 'SGmLXP']);
        break;
      case 'es': 
        // @ts-ignore
        window._klOnsite.push(['openForm', 'Tdj5gs']);
        break;
      case 'uk':
        // @ts-ignore
        window._klOnsite.push(['openForm', 'VR8ga3']);
        break;
        
      default:
        break;
    }
  })
}

async function waitForKlaviyoThen(callback: Function) {
  let totalWaitTime = 0;
  const interval = setInterval(() => {
    totalWaitTime += 100;
    // @ts-ignore klaviyo does not exist until the klaviyo script is loaded
    if (typeof klaviyo !== 'undefined') {
      clearInterval(interval);
      callback();
    }
    if (totalWaitTime >= 3000) {
      clearInterval(interval);
    }
  }, 100);
}